import { getTheme } from '@truvhq/ui';

export const theme = getTheme();
